import * as types from './types'
export default {
  [types.SET_FILES](state, files) {
    state.files = files
  },
  [types.SET_FILE](state, file) {
    state.file = file
  },
  [types.SET_THUMBS](state, thumbs) {
    state.thumbs = thumbs
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/files/mutations.js